// extracted by mini-css-extract-plugin
export var Image = "blog-module--Image--1bvgG";
export var Content = "blog-module--Content--3CrNC";
export var Date = "blog-module--Date--NRLFE";
export var Tags = "blog-module--Tags--cskF-";
export var BlogLink = "blog-module--BlogLink--2aBoS";